import { Campanha } from '../../../../../campanhas/campanhas';
import { OrigemID, Origem } from '../../../../../common/origens/domain';
import { CanalVenda } from '../../../../../common/canais-venda/domain';
import { isTipoPessoaCentralCompras, isTipoPessoaFisica, isTipoPessoaFisicaOuJuridica, isTipoPessoaJuridica, pessoaJuridica } from '../../../../../pessoa/tipo/pessoa-tipo';
import { Lead } from '../../../lead';
import { Usuario } from '../../../../../usuario/usuario';

export class LeadPreInsert {
    origem: number;
    idCampanhaOrigem: number;
    campanhaOrigem: Campanha;
    canalMidiaSocial: number;
    // Canal de Venda
    idCanalVendaOrigem: number;
    canalVendaOrigem: CanalVenda;
    idUsuarioResponsavel: number;
    usuarioResponsavel: Usuario;
    temperatura: number;
    tipoPessoa: number;
    cnpjCpf: string;
    exterior: boolean;
    nome: string;
    leadPessoaJuridica: Lead;

    constructor() {
        this.tipoPessoa = pessoaJuridica.id;
        this.exterior = false;
    }

    /** Verifica se o tipo da pessoa é Fisica */
    isTipoPessoaFisica(): boolean {
        return isTipoPessoaFisica(this.tipoPessoa);
    }

    /** Verifica se o tipo da pessoa é Juridica */
    isTipoPessoaJuridica(): boolean {
        return isTipoPessoaJuridica(this.tipoPessoa);
    }

    /** Verifica se o tipo da pessoa é Fisica ou Juridica */
    isTipoPessoaFisicaOuJuridica(): boolean {
        return isTipoPessoaFisicaOuJuridica(this.tipoPessoa);
    }

    /** Verifica se o tipo da pessoa é Central de Compras */
    isTipoPessoaCentralCompras(): boolean {
        return isTipoPessoaCentralCompras(this.tipoPessoa);
    }

    /** Verifica se a origem do lead é campanha */
    isOrigemCampanha(): boolean {
        return OrigemID.isOrigemCampanha(this.origem);
    }

    /** Verifica se a origem do lead é mídia social */
    isOrigemMidiaSocial(): boolean {
        return OrigemID.isOrigemMidiaSocial(this.origem);
    }

    /** Verifica se a origem possui canal de venda */
    isOrigemPossuiCanalVenda(): boolean {
        // Obtendo a origem do cliente
        const origem = Origem.getById(this.origem);
        // Somente exibe o canal de venda se a origem possuir
        return origem?.possuiCanalVenda ?? false;
    }
}
